<template>
  <div>
    <div class="right" :style="{borderLeft: '1px solid #CACACA', height: '100%'}">
      <div>
        服務費
        <Select1 :defaultValue="area" @input="area=$event;addnew=false;itemSelected=null" :width="'350px'">
          <option :value="null">全部</option>
          <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
        </Select1>
        <RBtn @click="edit=true" :bg="'var(--color-pri)'" :icon="'add'" :text="'新增服務費'" :style="{marginLeft: 'auto'}"/>
        <template v-if="draggable" >
          <AddBtn @click="draggable=false;getdata()" :bg="'#B9B9B9'" :text="'取消'" />
          <AddBtn @click="saveSort" :bg="'var(--highlight)'" :text="'儲存排序'" :icon="'sort'"/>
        </template>
        <AddBtn @click="draggable=true" v-else :bg="'var(--point)'" :text="'編輯排序'" :icon="'sort'"/>
      </div>
      <Table :rows="rows" :draggable="draggable" @sort="rows=$event">
        <template slot="slot_head">
          <th :style="{textAlign: 'start', width: 'inherit'}">名稱</th>
          <th :style="{textAlign: 'start', width: 'inherit'}">條件/折扣</th>
          <th :style="{textAlign: 'start', width: '400px'}">適用區域</th>
          <th :style="{textAlign: 'start', width: '160px'}">新增時間</th>
          <th :style="{textAlign: 'start', width: '160px'}">更新時間</th>
          <th :style="{textAlign: 'center'}">修改</th>
          <th :style="{textAlign: 'center'}">清除</th>
        </template>
        <tr slot-scope="{item, index}" :style="{height: '100px', border: 'none', position:'relative'}">
          <td :style="{textAlign: 'start'}">{{item.name}}</td>
          <td :style="{textAlign: 'start'}">消費總額加上{{item.cond}}%</td>
          <td :style="{textAlign: 'start', maxWidth: '400px'}"><div :style="{display: 'flex', gap: '.5em', flexWrap: 'wrap', lineHeight: '1em', height: '100%', alignItems: 'center'}" v-html="(item.store||[]).map(e => `<span>${e}</span>`).join(' / ')"/></td>
          <!-- <td :style="{textAlign: 'start'}">{{item.store}}</td> -->
          <td :style="{textAlign: 'start'}">
            <div :style="{whiteSpace: 'nowrap'}">{{moment(item.createTime).format('yyyy-MM-DD')}}</div>
            <div>{{moment(item.createTime).format('HH:mm')}}</div>
          </td>
          <td :style="{textAlign: 'start'}">
            <div :style="{whiteSpace: 'nowrap'}">{{moment(item.updateTime).format('yyyy-MM-DD')}}</div>
            <div>{{moment(item.updateTime).format('HH:mm')}}</div>
          </td>
          <td><EditBtn @click="setItem(item)" :style="{margin: 'auto'}"/></td>
          <td><DelBtn @click="deleteItem={_id: item._id, index, name: item.name}" :style="{margin: 'auto'}"/></td>
        </tr>
      </Table>
    </div>
    <DialogDef2 :show="edit" @close="clear" :label="'服務費'">
      <div class="editDiscount" :style="{padding: '0 53px 30px', display: 'flex', flexDirection: 'column', gap: '15px', maxWidth: '770px', margin: '26px 10px', maxHeight: '70vh', overflowY: 'auto'}">
        <div class="field">
          <div>名稱</div>
          <NormalInput :width="'394px'" :style="{height: '45px'}"
            :defaultValue="name" @input="name=$event"/>
        </div>
        <div class="field">
          <div>條件</div>
          <div :style="{display: 'flex', gap: '10px', lineHeight: '40px'}">
            <span>消費總額加上</span>
            <NormalInput :width="'113px'" :defaultValue="cond" @input="cond=parseInt($event)" :center="true"/>
            <span>% 服務費</span>
          </div>
        </div>
        <div class="field">
          <div>適用區域</div>
          <CheckBox :defaultValue="store" @input="store=$event" :options="restaurants" :style="{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)'}"></CheckBox>
        </div>
      </div>
      <Btns v-if="id" :align="'center'" :style="{marginInline: 'auto', marginBottom: '39px'}" @save="update" @cancel="clear"/>
      <Btns v-else :align="'center'" :style="{marginInline: 'auto', marginBottom: '39px'}" :save="'新增'" @save="add" @cancel="clear"/>
    </DialogDef2>
    <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="del(deleteItem._id, deleteItem.index)" @cancel="deleteItem=null"/>
  </div>
</template>

<script>
import RBtn from '../../components/btn/round.vue'
import AddBtn from '../../components/btn/sqr40016.vue'
import DelBtn from '../../components/btn/del.vue'
import EditBtn from '../../components/btn/edit.vue'
import NormalInput from '../../components/input/normal.vue'
import Btns from '../../components/btn/btns.vue'
import Table from '../../components/tables/t2_drag.vue'
import { getapi, putapi, deleteapi, postapi } from '../../store/fetch'
import CheckBox from '../../components/checkbox/checkbox.vue'
import { mapState } from 'vuex'
export default {
  components: {
    AddBtn,
    Table,
    Btns,
    NormalInput,
    DelBtn,
    EditBtn,
    RBtn,
    CheckBox
  },
  data () {
    return {
      deleteItem: null,
      area: null,
      draggable: false,
      rows: [],
      store: [],
      mode: '滿額折抵',
      name: null,
      cond: null,
      disc: null,
      id: null,
      Sets: [],
      edit: false
    }
  },
  computed: {
    sorted () {
      return this.rows.map(e => e._id)
    },
    ...mapState({
      restaurants: 'restaurants',
      defaultArea: 'store'
    })
  },
  watch: {
    area () {
      this.getdata()
    }
  },
  async mounted () {
    if (this.defaultArea) {
      this.area = this.defaultArea
    }
    await this.getdata()
  },
  methods: {
    async saveSort () {
      const body = { items: this.sorted }
      if (this.area) {
        body.store = this.area
      }
      const r = await postapi('discount/service/sort', body)
      console.log('r', r)
      if (r) {
        this.draggable = false
        await this.getdata()
      }
    },
    async getdata () {
      const r = await getapi(this.area ? `discount/service/${this.area}` : 'discount/service')
      this.rows = r
    },
    setItem ({ _id, name, cond, store }) {
      this.id = _id
      this.cond = cond ? parseInt(cond) : 0
      this.name = name
      this.store = store || []
      this.edit = true
    },
    clear () {
      this.name = null
      this.id = null
      this.cond = null
      this.store = []
      this.edit = false
    },
    async add () {
      const body = {
        name: this.name,
        cond: this.cond,
        store: this.store
      }
      const r = await putapi('discount/service', body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    },
    async del (id, index) {
      const r = await deleteapi(`discount/service/${id}`)
      if (r) {
        this.rows.splice(index, 1)
        this.deleteItem = null
      }
    },
    async update () {
      const body = {
        name: this.name,
        store: this.store,
        cond: this.cond
      }
      const r = await postapi(`discount/service/${this.id}`, body)
      if (r) {
        await this.getdata()
        this.clear()
      }
    }
  }

}
</script>
<style lang="scss">
.leftRadio {
  input[type=radio] {
    background-color: #FFFFFF;
    border: 1px solid var(--color-pri);
    color: var(--color-pri);
    &:checked {
      background-color: var(--color-pri);
      color: #FFFFFF;
    }
  }
}
.editDiscount {
    #setDateRange-wrapper {
      width: 394px!important;
      border: 1px solid #CACACA;
    }
    #setDateRange-input {
      border: none!important;
    }
    input[type=text][name=searchText] {
      height: 44px;
    }
}
</style>
<style lang="scss" scoped>
.note {
  width: 30px;
  height: 30px;
  background-image: url(/remark.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.selectAll {
  color: #FFF;
  text-align: center;
  font-family: Noto Sans TC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.6px;
  background-color: var(--highlight);
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 69px;
  border-radius: 3px;
  position: absolute;
  left: 0;
}
.fil {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 31px 10px 26px;
  background: #E9F5FC;
}
.list {
  overflow-y: auto;
  margin-inline: 5px;
  padding-inline: 26px;
}
.pointingProduct {
  display: grid;
  grid-template-rows: 70px 1fr 70px;
  gap: 10px;
  max-height: 700px;
}
.specitem {
  padding: 0px 8px;
  border-radius: 3px;
  border: 1px solid var(--color-pri);
  color: var(--color-pri);
  font-size: 18px;
  height: 50px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  &.set {
    background-color: var(--color-pri);
    color: #FFFFFF;
  }
}
.setTitle {
  font-size: 20px;
  letter-spacing: .3em;
  position: relative;
}
.setli {
  width: 100%;
  label {
    width: 100%;
    display: inline-flex;
    gap: 15px;
    font-size: 20px;
    accent-color: var(--color-pri);
    height: 65px;
    align-items: center;
    color: #787878;
    input[type=checkbox] {
      appearance: none;
      width: 30px;
      height: 30px;
      background-color: #FFFFFF;
      border: 1px solid var(--color-pri);
      border-radius: 5px;
      &:checked {
        background-color: var(--color-pri);
        background-image: url(/svg/checkbox/checkmark.svg);
        background-position: center;
        background-repeat: no-repeat;

      }
    }
  }
}
.leftHead {
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-pri);
}
.field {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-top: 20px;
  &>div:nth-child(1) {
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
    font-weight: 400;
    font-size: 18px;
    text-align: right;
    letter-spacing: 0.1em;
    color: #787878;
    display: block;
    width: 82px;
  }
  span {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: #6D6D6D;
  }
  textarea {
    width: 394px;
    height: 120px;
    font-size: 16px;
    letter-spacing: .05em;
    border: 1px solid #959595;
    border-radius: 5px;
    padding: 8px 16px;
  }
}
.right {
  display: grid;
  grid-template-rows: 70px 1fr;
  grid-template-columns: 100%;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 32px;
    padding-inline: 46px;
    font-weight: 500;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0.05em;
    color: var(--color-pri);
  }
}
</style>
